<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <center>
          <!-- <v-img height="100%" :src="imageHeadHRM"></v-img> -->
          <v-card color="#385F73" dark max-width="auto">
            <!-- <v-container fluid> -->
            <v-card-actions>
              <v-list-item class="grow">
                <v-list-item-avatar size="80" color="grey darken-3">
                  <v-img
                    class="elevation-6"
                    alt=""
                    :src="profile.empImageUrl"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">
                    {{ profile.empFull_NameTH }}
                  </v-list-item-title>
                  <v-list-item-title class="text-h6">
                    {{ profile.empCode }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{
                    profile.positionName
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle
                    >{{ profile.masDepartmentName }} :
                    {{ profile.masBranchName }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card-actions>
            <!-- </v-container> -->
          </v-card>
          <v-card>
            <v-img
              @click="Home()"
              :lazy-src="imageUrlBack"
              max-height="30"
              max-width="100"
              :src="imageUrlBack"
            ></v-img>
            <v-sheet tile height="54" class="d-flex">
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon color="#871B12" size="30"
                >mdi-calendar-search</v-icon
              >
            </v-sheet>

            <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <v-card> <div>
    <h6>คะแนนปฏิบัติงาน</h6>
    <v-card>
    <div class="outer">
    <canvas id="myChartWork" width="600" height="400"></canvas>
    </div>
              </v-card>
  </div> </v-card>
              </v-col>
            </v-row>
          </v-container>
          </v-card>
          <!-- <C3Chart :chartData="handlerChart" v-if="handlerChart"></C3Chart> -->
        </center>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'

import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
// import C3Chart from '../C3/C3Chart.vue'
export default {
  components: {
    moment
    // C3Chart
  },
  name: 'Info',
  data () {
    return {
      imageUrlBack: '',
      PK: '',
      path: '/shift_import/', // Path Model
      // Menu Config
      value: '',
      month: '',
      year: '',
      startdate: this.getDateTh(),
      shift: [],
      profile: [],
      dataShiftItem: [],
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      events: [],
      focus: '',
      handlerChart: null
    }
  },
  async mounted () {
    let _this = this
    this.handlerChart = {
      data: {
        columns: [
          ['padded1', 100],
          ['padded2', 90],
          ['padded3', 50],
          ['padded4', 20]
        ],
        type: 'gauge',
        onclick: function (d, i) { _this.getDataChart(d) }
      },
      color: {
        pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'],
        threshold: {
          values: [30, 80, 95]
        }
      },
      size: {
        height: 320
      }
    }
    // this.getGetToken()
    this.dataReady = false
    let date = new Date()
    this.focus = date
    // Get Data
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    // await this.getDataEmp()
    await this.charJSWork()
  },
  methods: {
    getDataChart (dt) {
      console.log(dt)
    },
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getDataEmp () {
      let data = JSON.parse(localStorage.getItem('liff_info'))
      console.log('data', data)

      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee/' +
            'getEmp_by_empCode?empCode=' +
            data.empCode
        )
        .then(async (response) => {
          if (response.data[0].empCode) {
            this.profile = response.data[0]
            await this.makeRequest(
              this.DNS_IP + '/' + this.profile.empImageUrl
            )

            localStorage.setItem('liff_info', JSON.stringify(this.profile))

            await this.navigation()
            this.dataReady = false

            //
          } else {
            this.$swal(
              'ไม่พบรหัสพนักงาน',
              'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล',
              'error'
            )
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    makeRequest (imageUrl) {
      if (imageUrl) {
        fetch(imageUrl)
          .then((response) => {
            this.profile.empImageUrl = imageUrl
            console.log('imageUrl: ', imageUrl) // 👉️ 200
            console.log('status: ', response.status) // 👉️ 200
            console.log(response)
          })
          .catch((err) => {
            this.profile.empImageUrl = this.form.userLinepictureUrl
            console.log(err)
          })

        console.log('userLinepictureUrl: ', this.form.userLinepictureUrl) // 👉️ 200
        console.log('imageUrl: ', this.profile.empImageUrl) // 👉️ 200
      }
    },
    async charJSWork () {
      var ctx = document.getElementById('myChartWork')
      // let _this = this
      var myChartWork = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'doughnut',
        data: {
          labels: ['คะแนนที่ได้', 'คะแนนที่หัก'],
          datasets: [{
            label: '# of Votes',
            data: [100, 20],
            backgroundColor: [
              'rgba(46, 204, 113, 1)',
              'rgba(255, 164, 46, 1)'

            ],
            borderColor: [
              'rgba(255, 255, 255 ,1)',
              'rgba(255, 255, 255 ,1)'
            ],
            borderWidth: 5

          }]
        },
        options: {
          plugins: {
            datalabels: {
              color: 'white',
              // display: function (context) {
              //   return context.dataset.data[context.dataIndex] > 15
              // },
              font: {
                weight: 'bold',
                size: 16
              }
              // formatter: Math.round
            }
          },
          responsive: true,
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          title: {
            display: true,
            text: 'Custom Chart Title',
            position: 'bottom'
          },
          onClick: (e, activeEls) => {
            var activePoints = myChartWork.getElementsAtEvent(e)
            if (activePoints.length > 0) {
              var selectedIndex = activePoints[0]._index
              console.log(selectedIndex)
            }
          }
        }
      })
      console.log(myChartWork)
    },
    async chart () {
      // var chart = c3.generate({
      //   data: {
      //     columns: [
      //       ['data1', 30],
      //       ['data2', 120]
      //     ],
      //     type: 'gauge',
      //     onclick: function (d, i) { alert('Fuck' + JSON.stringify(d)) },
      //     onmouseover: function (d, i) { console.log('onmouseover', d, i) },
      //     onmouseout: function (d, i) { console.log('onmouseout', d, i) }
      //   },
      //   donut: {
      //     title: 'Iris Petal Width'
      //   }
      // })

      // setTimeout(function () {
      //   chart.load({
      //     columns: [
      //       ['setosa', 0.2, 0.2, 0.2, 0.2, 0.2, 0.4, 0.3, 0.2, 0.2, 0.1, 0.2, 0.2, 0.1, 0.1, 0.2, 0.4, 0.4, 0.3, 0.3, 0.3, 0.2, 0.4, 0.2, 0.5, 0.2, 0.2, 0.4, 0.2, 0.2, 0.2, 0.2, 0.4, 0.1, 0.2, 0.2, 0.2, 0.2, 0.1, 0.2, 0.2, 0.3, 0.3, 0.2, 0.6, 0.4, 0.3, 0.2, 0.2, 0.2, 0.2],
      //       ['versicolor', 1.4, 1.5, 1.5, 1.3, 1.5, 1.3, 1.6, 1.0, 1.3, 1.4, 1.0, 1.5, 1.0, 1.4, 1.3, 1.4, 1.5, 1.0, 1.5, 1.1, 1.8, 1.3, 1.5, 1.2, 1.3, 1.4, 1.4, 1.7, 1.5, 1.0, 1.1, 1.0, 1.2, 1.6, 1.5, 1.6, 1.5, 1.3, 1.3, 1.3, 1.2, 1.4, 1.2, 1.0, 1.3, 1.2, 1.3, 1.3, 1.1, 1.3],
      //       ['virginica', 2.5, 1.9, 2.1, 1.8, 2.2, 2.1, 1.7, 1.8, 1.8, 2.5, 2.0, 1.9, 2.1, 2.0, 2.4, 2.3, 1.8, 2.2, 2.3, 1.5, 2.3, 2.0, 2.0, 1.8, 2.1, 1.8, 1.8, 1.8, 2.1, 1.6, 1.9, 2.0, 2.2, 1.5, 1.4, 2.3, 2.4, 1.8, 1.8, 2.1, 2.4, 2.3, 1.9, 2.3, 2.5, 2.3, 1.9, 2.0, 2.3, 1.8]
      //     ]
      //   })
      // }, 1500)

      // setTimeout(function () {
      //   chart.unload({
      //     ids: 'data1'
      //   })
      //   chart.unload({
      //     ids: 'data2'
      //   })
      // }, 2500)
    }
  }
}
</script>
<style>
@import '../../assets/c3.min.css';
</style>



// WEBPACK FOOTER //
// src/components/Liff/Attendance.vue